import { getDashboardStats } from '../services/api';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DashboardStats {
  projects: {
    total: number;
    inProgress: number;
  };
  finance: {
    totalBudget: number;
    paidAmount: number;
    pendingAmount: number;
    /** 可請款：里程碑（或分包、專案）已完成、還沒請款 */
    billable: { count: number; amount: number };
    /** 收款逾期：已請款、過了預計收款日還沒收齊 */
    paymentOverdue?: { count: number; amount: number };
  };
  tasks: {
    overdue: number;
    myTasks: any[];
  };
  recentProjects: any[];
}

interface DashboardState {
  stats: DashboardStats | null;
  error: string | null;
  lastFetchTime: number | null;

  fetchDashboardStats: () => Promise<void>;
}

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set) => ({
      stats: null,
      error: null,
      lastFetchTime: null,

      // 畫面先顯示上次的數字（persist），這裡一律重抓
      fetchDashboardStats: async () => {
        set({ error: null });
        try {
          const response = await getDashboardStats();
          set({ stats: response.data, lastFetchTime: Date.now() });
        } catch (err: any) {
          set({ error: err.message || 'An unknown error occurred' });
        }
      },
    }),
    {
      name: 'pm-dashboard-storage',
      partialize: (state) => ({
        stats: state.stats,
        lastFetchTime: state.lastFetchTime,
      }),
    }
  )
);
